import {getAdjustedPlantId} from '@hconnect/upm'

import {useSettingsQuery} from '../../../common/providers/ApiInterface'

import {useUrlParam} from '@settings/modules/routing'

export const useGetPlantUpmId = () => {
  const plantCode = useUrlParam('plantCode')
  return useSettingsQuery('upmId', [getAdjustedPlantId(plantCode)], {
    gcTime: 0,
    retry: false,
    staleTime: 0,
    enabled: !!plantCode
  })
}

export const QueryKey = 'upmId'
